import __vue_component__ from '../Checkbox/Checkbox.vue.js';
import { EventBus } from '../event-bus.js';

//
const LIST_NESTING_MARGIN = '24';
var script = {
  name: 'Label',
  components: {
    Checkbox: __vue_component__
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: () => ({})
    },
    hovered: {
      type: [Number, String],
      default: undefined
    },
    level: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      remoteSelectEventListener: undefined
    };
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },

      set() {
        this.$emit('input', this.node.id);
      }

    },

    current() {
      return this.hovered === this.node.id.toString();
    },

    indent() {
      if (this.$slots.chevron) {
        return (this.level - 1) * LIST_NESTING_MARGIN;
      }

      return this.level * LIST_NESTING_MARGIN;
    }

  },
  watch: {
    current(isCurrent) {
      if (isCurrent) {
        this.$emit('current');
        this.$nextTick(() => {
          if (!this.$refs.label) return;
          const isMicrosoftBrowser = new RegExp(['MSIE ', 'Edge/'].join('|')).test(navigator.userAgent);
          if (isMicrosoftBrowser) return;
          this.$refs.label.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        });
      }
    }

  },

  mounted() {
    this.remoteSelectEventListener = () => {
      if (this.current) {
        this.$emit('input', this.node.id);
      }
    };

    EventBus.$on('remote-select', this.remoteSelectEventListener);
  },

  destroyed() {
    EventBus.$off('remote-select', this.remoteSelectEventListener);
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tree/Label.vue_rollup-plugin-vue=script.js